// extracted by mini-css-extract-plugin
export default {"navigateBtnCol":"specialNoteDetails_navigateBtnCol__z9aMG","dividerLine":"specialNoteDetails_dividerLine__LXd-a"};